export default __webpack_public_path__ + "static/media/employees and me.9d12a9ee.png";